import { render, staticRenderFns } from "./DiemDenList.vue?vue&type=template&id=520210c3"
import script from "./DiemDenList.vue?vue&type=script&lang=js"
export * from "./DiemDenList.vue?vue&type=script&lang=js"
import style0 from "./DiemDenList.vue?vue&type=style&index=0&id=520210c3&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports